const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Shortcode", "uipress-lite"),
  moduleName: "uip-shortcode",
  description: __("This block allows you to output custom shortcodes into the template", "uipress-lite"),
  category: __("Elements", "uipress-pro"),
  group: "elements",
  icon: "code_blocks",
};
